import type { ISEO } from './types';

const SEO = ({
  canonical = '',
  metaRobotsNofollow = 'follow',
  metaRobotsNoindex = 'index',
  uri,
  isPaginated,
  prevPagePath,
  nextPagePath,
}: ISEO) => {
  const canonicalUrl = canonical ?? uri;

  return (
      <>
        <meta id="meta-robots-tag" name="robots" content={[metaRobotsNoindex, metaRobotsNofollow].filter(Boolean).join(', ')} />
        <link id="link-rel-canonical" rel="canonical" href={canonicalUrl.replace(/([^:]\/)\/+/g, '$1')} />
        {isPaginated && Boolean(prevPagePath) && <link id="link-rel-prev" rel="prev" href={prevPagePath} />}
        {isPaginated && Boolean(nextPagePath) && <link id="link-rel-next" rel="next" href={nextPagePath} />}
      </>
  );
};

export default SEO;
